import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface DisableVasWizardRequestDto {
    socId: number,
    activeTo?: string,
    zoneId?: number,
    seUserId?: number,
    eqlAgrContent?: number,
    addendaDomrutv?: number,
}

/**
 * Отключение VAS
 * @link https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Vas/5e6e97d82d892749a945286cdf7d136f
 */
export const disableVasWizard = (body: DisableVasWizardRequestDto): IRequest => ({
    uri: '/v1/vas/disabled-vas-wizard',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(body),
});
